/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The HighlightedString component is used to indicate matched text
 * in a UI. The primary use case is for search results.
 *
 * ## Related Components
 * - [Player](../Player/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <HighlightedString
 *   segments={[
 *     { value: 'foo', isHighlighted: false },
 *     { value: 'bar', isHighlighted: true },
 *   ]}
 * />
 *```
 *
 * ## Props
 */

var HighlightedString = function HighlightedString(props) {
  var qa = props.qa,
      segments = props.segments,
      className = props.className;

  var _HighlightedString$ge = HighlightedString.getClassName({
    className: className
  }),
      root = _HighlightedString$ge.root,
      highlight = _HighlightedString$ge.highlight;

  return /*#__PURE__*/React.createElement("span", {
    "data-qa": qa,
    className: root
  }, segments.map(function (_ref, idx) {
    var isHighlighted = _ref.isHighlighted,
        value = _ref.value;
    return isHighlighted ? /*#__PURE__*/React.createElement("span", {
      "data-qa": "".concat(qa, "#highlightedSegment").concat(idx),
      key: "".concat(value, "-").concat(idx),
      className: highlight
    }, value) : value;
  }));
};

HighlightedString.getClassName = function (_ref2) {
  var className = _ref2.className;
  return {
    root: cx(className, 'psw-highlighted-string'),
    highlight: cx('psw-c-accent-1')
  };
};

HighlightedString.useClassNames = function (classNames) {
  HighlightedString.classNames = classNames;
};

HighlightedString.defaultProps = {
  qa: '',
  className: '',
  segments: []
};
HighlightedString.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * All string segments making up the full string
   */
  segments: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Whether the particular segment should be highlighted or not
     */
    isHighlighted: PropTypes.bool,

    /**
     * The string value of the segment
     */
    value: PropTypes.string
  }))
};
cx = classNamesFor(HighlightedString);
export default HighlightedString;